// extracted by mini-css-extract-plugin
module.exports = {"container":"Image_container__1Lj7D","image":"Image_image__2xV1A","content":"Image_content__3xGoF","fakeImg":"Image_fakeImg__PiEUj"};